import { render, staticRenderFns } from "./Customer.vue?vue&type=template&id=08d5ac5c&scoped=true"
import script from "./Customer.vue?vue&type=script&lang=js"
export * from "./Customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d5ac5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08d5ac5c')) {
      api.createRecord('08d5ac5c', component.options)
    } else {
      api.reload('08d5ac5c', component.options)
    }
    module.hot.accept("./Customer.vue?vue&type=template&id=08d5ac5c&scoped=true", function () {
      api.rerender('08d5ac5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/bulletinBoard/receivablesStatistics/Customer.vue"
export default component.exports